import Settings from "./settings";
import Helpers from "./helpers";

var PlansMiddleMan = {};

var prefix = Settings.plans_prefix;

PlansMiddleMan.checkPlanInterface = (processedPlan) => {};

PlansMiddleMan.processAvailablePlansAPI = (response) => {
	let byProductCode = {};

	for (let productGroup of response) {
		byProductCode[productGroup.ProductCode] = {};

		let subplans = {};
		for (let subplan of productGroup.AvailablePlans) {
			let final_sub = PlansMiddleMan.processSubPlan(subplan);
			subplans[subplan.ID] = final_sub;
		}

		let packages = {};

		for (let pack of productGroup.PackagesPricingTable) {
			let packageProcessed = PlansMiddleMan.processPackagePlan(pack, subplans);

			let lookup_id = packageProcessed[prefix + "subplans_ids_sorted"];

			packages[lookup_id.join(",")] = packageProcessed;
		}

		let locked_plans = PlansMiddleMan.processLockedPlans(
			productGroup.locked_plans
		);

		byProductCode[productGroup.ProductCode][prefix + "subplans"] = subplans;
		byProductCode[productGroup.ProductCode][prefix + "promotions"] =
			productGroup.Promotions;
		byProductCode[productGroup.ProductCode][prefix + "packages"] = packages;
		byProductCode[productGroup.ProductCode][
			prefix + "locked_plans"
		] = locked_plans;
	}

	return byProductCode;
};

PlansMiddleMan.processSavedPlan = (pack) => {
	let subplans_ids = [];
	let subplans = {};
	for (let subplan of pack.Plans) {
		subplans[subplan.ID] = PlansMiddleMan.processSubPlan(subplan);
		subplans_ids.push(subplan.ID);
	}

	subplans_ids = subplans_ids.sort();
	let subplans_by_type = {};
	for (let subplans_id of subplans_ids) {
		let subplan = subplans[subplans_id];
		subplans_by_type[subplan.Type] = subplans_id;
	}
	pack[prefix + "subplans_ids_sorted"] = subplans_ids;
	pack[prefix + "subplans_ids_by_type"] = subplans_by_type;
	pack[prefix + "subplans"] = subplans;

	let PackagePriceArr = {...pack["PackagePrice"]};

	pack["PackagePrice"] = PackagePriceArr[0];

	let spotii_extra = null;

	if(PackagePriceArr[1]){
		for(let extra of PackagePriceArr[1]["ExtraCharges"]){
			if (extra["Name"] === "Spotii") {
				spotii_extra = extra;
				break;
			}
		}
	}
	
	pack["Spotii"] = spotii_extra;

	return pack;
};

PlansMiddleMan.processVanityPlan = (pack) => {
	let subplans_ids = [];
	let subplans = {};
	for (let subplan of pack.plans) {
		subplans[subplan.ID] = PlansMiddleMan.processSubPlan(subplan);
		subplans_ids.push(subplan.ID);
	}

	subplans_ids = subplans_ids.sort();
	let subplans_by_type = {};
	for (let subplans_id of subplans_ids) {
		let subplan = subplans[subplans_id];
		subplans_by_type[subplan.Type] = subplans_id;
	}
	pack[prefix + "subplans_ids_sorted"] = subplans_ids;
	pack[prefix + "subplans_ids_by_type"] = subplans_by_type;
	pack[prefix + "subplans"] = subplans;

	pack["PackagePrice"] = {...pack["package_price"]};

	delete pack["package_price"];
	
	return pack;
};

PlansMiddleMan.processPackagePlan = (pack, allsubplans) => {
	let subplans_ids = pack.Plans.sort();

	let subplans_by_type = {};

	let package_subplans = {};
	for (let subplans_id of subplans_ids) {
		let subplan = allsubplans[subplans_id];
		subplans_by_type[subplan?.Type] = subplans_id;
		package_subplans[subplans_id] = subplan;
	}

	delete pack["Plans"];

	pack[prefix + "subplans_ids_sorted"] = subplans_ids;
	pack[prefix + "subplans_ids_by_type"] = subplans_by_type;
	pack[prefix + "subplans"] = package_subplans;

	return pack;
};

PlansMiddleMan.processLockedPlans = (data) => {

	let locked = {
		by_trigger: {},
		by_lookup: [],
	};

	// by lock trigger then lookup
	for (let item of data) {
		let subplans_ids = item.plan.sort();
		let subplans_ids_string = subplans_ids.join(",");
		locked["by_trigger"][item["lock_trigger_id"]] = subplans_ids;
		locked["by_lookup"].push(subplans_ids_string);
	}

	return locked;
};

PlansMiddleMan.processSubPlan = (rawSubplan) => {
	if (rawSubplan.Value === Settings.unlimited_value) {
		rawSubplan[prefix + "ValueFormatted"] = Settings.unlimited_text;
	} else {
		if (rawSubplan.Type === "DATA") {
			let pair = Helpers.getUnitValuePairFromBytes(
				rawSubplan.Value,
				true,
				false
			);
			rawSubplan[prefix + "ValueFormatted"] = pair["value"];
			rawSubplan[prefix + "UnitFormatted"] = pair["unit"];
		} else {
			rawSubplan[prefix + "ValueFormatted"] = Helpers.milisecondstoMinutes(
				rawSubplan["Value"]
			);
			rawSubplan[prefix + "UnitFormatted"] = "min/SMS";
		}
	}

	return rawSubplan;
};

PlansMiddleMan.processBoosters = (response, daily = false) => {
	let processed_boosters = {};
	for (let type of Settings.types) {
		processed_boosters[type] = [];
	}
	for (let booster of response) {
		if (booster.Type === "DATA") {
			if (booster.Value === Settings.unlimited_value) {
				booster[prefix + "ValueFormatted"] = Settings.unlimited_text;
			} else {
				let pair = Helpers.getUnitValuePairFromBytes(booster.Value, false, true);
				booster[prefix + "ValueFormatted"] = pair["value"];
				booster[prefix + "ValueUnit"] = pair["unit"];
			}

			let pair = Helpers.getUnitValuePairFromBytes(
				booster.DailyAllowanceValue,
				false,
				true
			);
			booster[prefix + "DailyAllowanceValueFormatted"] = pair["value"];
			booster[prefix + "DailyAllowanceUnitFormatted"] = pair["unit"];
		}
		if (booster.Type === "VOICE-LCL" || booster.Type === "VOICE-INT") {
			if (booster.Value === Settings.unlimited_value) {
				booster[prefix + "ValueFormatted"] = Settings.unlimited_text;
			} else {
				booster[prefix + "ValueFormatted"] = Helpers.milisecondstoMinutes(
					booster.Value
				);
			}
			booster[
				prefix + "DailyAllowanceValueFormatted"
			] = Helpers.milisecondstoMinutes(booster.DailyAllowanceValue);
			booster[prefix + "ValueUnit"] = "min/SMS";
			if (booster[prefix + "DailyAllowanceValueFormatted"] === Settings.unlimited_text) {
				booster[prefix + "ValueUnitd"] = "min";
			}
		}

		processed_boosters[booster.Type].push(booster);
	}
	return processed_boosters;
};

export default PlansMiddleMan;
